import trAntd from 'antd/es/locale/tr_TR';

const TrLang = {
  locale: 'tr',
  antd: trAntd,
  messages: {
    "topbar.notification": "Bildirimler",
    "topbar.notification.emptyMessage": "Bekleyen Bildiriminiz Yok",
    "topbar.viewAll": "Tümünü Gör",
    "topbar.changePassword": "Parola Değiştir",
    "topbar.logout": "Güvenli Çıkış",

    "app.auditors": "Denetçiler",
    "app.auditor": "Denetçi",
    "app.here": "Buraya",
    "app.yes": "Evet",
    "app.no": "Hayır",
    "app.plant": "Tesis",
    "app.customer": "Müşteri",
    "app.supplier": "Tedarikçi",
    "app.project": "Proje",
    "app.pinned": "Sabitlenenler",
    "app.record": "Kayıt",
    "app.allRecords": "Tüm Kayıtlar",
    "app.filterApplied": "Filtre Uygulandı",
    "app.version": "Sürüm",
    "app.currentVersion": "Mevcut Sürüm",
    "app.oldVersion": "Eski Sürüm",
    "app.open": "Açık",
    "app.closed": "Kapalı",
    "app.read": "Okundu",
    "app.unread": "Okunmadı",
    "app.customerCount": "Müşteri Sayısı",
    "app.itemSelected": "Öğe Seçildi",
    "app.all": "Hepsi",
    "app.file": "Dosya",
    "app.processing": "İşleminiz yapılıyor...",
    "app.update.success": "Başarıyla güncellendi.",
    "app.update.error": "Güncelleme sırasında bir hata oluştu. Lütfen tekrar deneyin.",
    "app.delete.success": "Başarıyla silindi.",
    "app.delete.error": "Silme sırasında bir hata oluştu. Lütfen tekrar deneyin.",
    "app.save.success": "Başarıyla kaydedildi",
    "app.save.error": "Kayıt sırasında bir hata oluştu. Lütfen tekrar deneyin.",
    "app.scope": "Kapsam",
    "app.breakdown": "Kırılım",
    "app.source": "Kaynak",
    "app.request.success": "İsteğiniz başarılı bir şekilde iletilmiştir.",
    "app.request.success.redirectProjectEdit": "İsteğiniz başarılı bir şekilde iletilmiştir. Proje düzenleme ekranına yönlendiriliyorsunuz...",
    "app.active": "Aktif",
    "app.inactive": "Pasif",
    "app.onlyEditableInFirstStage": "Sadece ilk aşamada değiştirilebilir!",
    "app.plantSupplier": "Tesis / Tedarikçi",
    "app.summary": "Özet",
    "app.integration": "Entegrasyon",
    "app.registration.success": "Kayıt işleminiz başarıyla gerçekleşmiştir. Giriş sayfasına yönlendiriliyorsunuz.",
    "app.retry": "Tekrar Dene",
    "app.pleaseWait": "İşleminiz tamamlanana kadar lütfen bekleyin.",
    "app.categories": "Kategoriler",
    "app.categories.placeholder": "Kategori Seçiniz",
    "app.formula": "Formül",
    "app.reference": "Referansı",
    "app.createdBy": "Oluşturan",
    "app.updatedBy": "Güncelleyen",
    "app.recordApproved": "Kaydınız onaylanmıştır.",
    "app.recordNotApproved": "Kayıt henüz onaylanmamıştır.",
    "app.filesSaved": "Kayıtlı Dosyalar",
    "app.overallTotal": "Genel Toplam",
    "app.upstream": "Yukarı Yönlü",
    "app.downstream": "Aşağı Yönlü",
    "app.numeric.placeholder": "örn. 100",
    "app.show.more": "Daha Fazla Göster (+{n})",
    "app.show.less": "Daha Az Göster",
    "eos.tooltip": "Karbon ayak izinizi dengelemek ister misiniz?",

    "invitation.link.invalid.title": "Bağlantı geçersiz",
    "invitation.link.invalid.subTitle": "Davet bağlantısı geçersiz veya süresi dolmuş olabilir. Lütfen müşteriyle iletişime geçerek yeni bir davet isteyin.",
    "invite.accepted": "Davet kabul edildi",
    "invite.accepted.success": "Başarıyla ilişkilendirildiniz. Artık bu müşteriyle tedarikçi olarak çalışmaya başlayabilirsiniz.",

    "relation.customerSupplier.title": "Müşteri tedarikçi ilişkisi",
    "relation.supplierInvitation.title": "Tedarikçi davetiyesi",
    "relation.customerSupplier.remove.confirm": "Müşteri ve tedarikçi ilişkisini kaldırmak istediğinize emin misiniz?",
    "relation.customerSupplier.add.confirm": "Müşteri ve tedarikçiyi ilişkilendirmek istediğinize emin misiniz?",
    "relation.supplierInvitation.send.confirm": "Tedarikçiye davetiye göndermek istediğinize emin misiniz?",

    "chart.trendline": "Eğilim Çizgisi",
    "chart.zoom": "Grafiği büyüt",
    "chart.defaultTitle": "Grafik",
    "chart.closeHint": "Kapatmak için sağ üstten çıkışa tıklayabilirsiniz.",

    "login.signIn": "Giriş Yap",
    "login.username.placeholder": "Kullanıcı Adı",
    "login.password.placeholder": "Parola",
    "login.forgotPassword": "Parolanızı mı unuttunuz?",
    "login.forgotPasswordQuestion": "Parolanızı unuttunuz mu?",
    "login.resetPasswordInstruction": "E-postanızı girin, size bir sıfırlama bağlantısı gönderelim.",
    "login.usernameOrEmail": "Kullanıcı Adı veya E-posta",
    "login.bookDemo": "Demo Talep Et",
    "login.bookDemo.subtitle": "Sürdürülebilirlik danışmanlarımızla hızlıca bir toplantı ayarlamak için <click>tıklayın</click>",

    "passwordChange.success": "Parola başarıyla değiştirildi.",
    "passwordChange.error": "Parola değişikliği başarısız oldu. Lütfen tekrar deneyin.",
    "passwordChange.expiredMessage": "Son parola değişikliğiniz 90 gün önceydi. Lütfen parolanızı güncelleyin.",
    "passwordChange.oldPassword": "Eski Parola",
    "passwordChange.newPassword": "Yeni Parola",
    "passwordChange.confirmPassword": "Parolayı Onayla",
    "passwordChange.oldPasswordRequired": "Eski Parola zorunludur!",
    "passwordChange.newPasswordRequired": "Yeni Parola zorunludur!",
    "passwordChange.confirmPasswordRequired": "Parolayı Onayla zorunludur!",
    "passwordChange.passwordsMustBeDifferent": "Eski parola ve yeni parola farklı olmalıdır!",
    "passwordChange.passwordsMustMatch": "Yeni parola ve onaylanan parola eşleşmelidir!",
    "passwordChange.passwordsMustBeAtLeast6Characters": "Parola en az 6 karakter uzunluğunda olmalıdır.",
    "paswordChange.passwordUpdate": "Parola Güncelleme",

    "sidebar.mainForm": "Dashboard",
    "sidebar.customer": "Müşteriler",
    "sidebar.supplier": "Tedarikçiler",
    "sidebar.plants": "Tesisler",
    "sidebar.projects": "Projeler",
    "sidebar.userList": "Kullanıcılar",
    "sidebar.emissionStatements": "Emisyon Faktörleri",
    "sidebar.notifications": "Bildirimler",
    "sidebar.fileHandler": "Dosya Yöneticisi",
    "sidebar.logs": "Olay Günlükleri",
    "sidebar.administrator": "Sistem",

    "projectWizard.title": "Proje Tanımlama",
    "projectWizard.validation.client.required": "Müşteri seçimi yapılması zorunludur.",
    "projectWizard.validation.protocolType.required": "Protokol türü seçimi yapılması zorunludur.",
    "projectWizard.validation.name.required": "Proje adı alanının doldurulması zorunludur.",
    "projectWizard.validation.start.required": "Başlangıç tarihi alanının doldurulması zorunludur.",
    "projectWizard.validation.end.required": "Bitiş tarihi alanının doldurulması zorunludur.",

    "project.compare": "Proje Karşılaştırma",
    "project.type": "Proje Türü",
    "projects.title": "Projeler",
    "projects.emptyMessage": "Sabitlenen Projeniz Yok",
    "projects.newProject": "Yeni Proje",
    "projects.createNewProject": "Yeni Proje Oluştur",
    "project.filter.events.title": "Etkinlik",
    "project.filter.events.placeholder": "Etkinlik projelerini dahil et",
    "project.filter.status.title": "Durum",
    "project.filter.status.placeholder": "Aktiflik durumu seçiniz",
    "project.filter.emissionStatus.title": "Emisyon Durumu",
    "project.filter.emissionStatus.placeholder": "Emisyon durumu seçiniz",
    "project.filter.protocolType.title": "Protokol Türü",
    "project.filter.protocolType.placeholder": "Protokol türü seçiniz",
    "project.filter.client.title": "Müşteri",
    "project.filter.client.placeholder": "Müşteri seçiniz",
    "project.filter.keyword.placeholder": "Proje Adı, Sürümü, Müşteri Adı ...Giriniz",
    "project.options.all": "Hepsi",
    "project.options.approvedOnly": "Sadece Onaylanan Projeler",
    "project.options.unapprovedOnly": "Sadece Onaylanmayan Projeler",
    "project.options.active": "Aktif",
    "project.options.inactive": "Pasif",
    "project.delete.title": "Projeyi Sil",
    "project.delete.message": "Bu projeyi silmek istediğinize emin misiniz?",
    "project.delete.success": "Proje başarıyla silindi.",
    "project.delete.error": "Proje silme işlemi başarısız oldu. Lütfen tekrar deneyin.",
    "project.compare.selectedProjects": "Seçilen Projeleri Karşılaştır",
    "project.compare.maxTwoProjectsAllowed": "Karşılaştırma için en fazla iki proje seçebilirsiniz.",
    "project.compare.sameProtocolRequired": "Karşılaştırılan projelerin aynı protokol türüne sahip olması gerekmektedir.",
    "project.card.emissionVersion": "Projede kullanılan Emisyon Sürümü",
    "project.card.auditor.notFound": "Atanan denetçi bulunamadı",
    "project.card.totalCO2e": "Toplam CO2e",
    "project.card.button.pin": "Sabitle",
    "project.card.button.unpin": "Sabitlenenlerden Çıkar",
    "project.column.name": "Adı",
    "project.column.client": "Müşteri",
    "project.column.status": "Durum",
    "project.column.version": "EF Sürüm",
    "project.column.version.tooltip": "Projede kullanılan Emisyon Faktörleri sürümünü belirtir",
    "project.column.protocolType": "Protokol Türü",
    "project.column.isEvent": "Etkinlik mi?",
    "project.type.event": "Etkinlik projesidir.",
    "project.pastDateWarning": "Bu proje geçmiş bir tarihe ait olduğundan aktif olarak kullanılamaz. Lütfen projenin durumunu 'Pasif' olarak güncelleyin.",
    "project.headquartersRelationRemoveError": "Projenin merkez tesisle ilişkisi kaldırılamaz.",
    "project.calculateAndAllocateSupplierEmissions.success": "Tedarikçi emisyonları başarıyla hesaplandı ve tahsis edildi.",
    "project.calculateAndAllocateSupplierEmissions.error": "Tedarikçi emisyonları hesaplanamadı ve tahsis edilemedi. Lütfen tekrar deneyin.",
    "project.calculateAndAllocateSupplierEmissions": "Onaylanmış aktarım yapılması gereken verileriniz bulunmaktadır.",
    "project.calculateAndAllocateSupplierEmissions.description": "Aktarımı Başlat",
    "project.supplierPlantQuantity.saveError": "Üretim hacmi kaydedilemedi. Lütfen tekrar deneyin.",
    "project.supplierPlantQuantity.saveSuccess": "Üretim hacmi başarıyla kaydedildi.",

    "plant.title": "Tesisler",
    "plant.newPlant": "Yeni Tesis",
    "plant.createNewPlant": "Yeni Tesis Oluştur",
    "plant.save.success": "Tesis başarıyla kaydedildi.",
    "plant.save.error": "Tesis kaydı başarısız oldu. Lütfen tekrar deneyin.",
    "plant.delete.title": "Tesis Sil",
    "plant.delete.message": "Bu tesisi silmek istediğinize emin misiniz?",
    "plant.delete.success": "Tesis başarıyla silindi.",
    "plant.delete.error": "Tesis silme işlemi başarısız oldu. Lütfen tekrar deneyin.",
    "plant.filter.customer.title": "Müşteriler",
    "plant.filter.customer.placeholder": "Müşteri Seçiniz",
    "plant.filter.keyword.placeholder": "Tesis Ünvanı, Adı, Vergi Dairesi ... Giriniz",
    "plant.column.customer": "Müşteri",
    "plant.relation.notFound": "İlişkilendirilmiş tesis bulunamadı",

    "versioningEmission.info": "Gerekli incelemeyi yaptıktan sonra kaydetmeyi unutmayınız!",
    "versioningEmission.title": "Emisyon Faktörleri - Versiyonlama / Ön İzleme",
    "versioningEmission.save.success": "Yeni emisyon sürümü başarıyla oluşturuldu",
    "versioningEmission.save.error": "Emisyon sürümü oluşturulamadı. Lütfen tekrar deneyin",

    "log.title": "Olay Günlükleri",
    "log.filter.user.title": "Kullanıcılar",
    "log.filter.user.placeholder": "Kullanıcı Seçiniz",
    "log.filter.logSource.title": "Olay Kaynağı",
    "log.filter.logSource.placeholder": "Olay Kaynağı Seçiniz",
    "log.filter.logType.title": "Olay Tipi",
    "log.filter.logType.placeholder": "Olay Tipi Seçiniz",
    "log.filter.keyword.placeholder": "Kullanıcı Adı, Soyadı, Açıklama ... Giriniz",
    "log.column.userName": "Kullanıcı Adı",
    "log.column.date": "Tarih",
    "log.column.logSource": "Olay Kaynağı",
    "log.column.logType": "Olay Tipi",
    "log.column.description": "Açıklama",
    "log.column.ipAddress": "IP Adresi",
    "log.column.roleName": "Yetki",

    "user.title": "Kullanıcılar",
    "user.newUser": "Yeni Kullanıcı",
    "user.createNewUser": "Yeni Kullanıcı Oluştur",
    "user.notFound": "Kullanıcı bulunamadı.",
    "user.save.success": "Kullanıcı başarıyla kaydedildi.",
    "user.save.error": "Kullanıcı kaydı başarısız oldu. Lütfen tekrar deneyin.",
    "user.delete.success": "Kullanıcı başarıyla silindi.",
    "user.delete.error": "Kullanıcı silme işlemi başarısız oldu. Lütfen tekrar deneyin.",
    "user.changePassword.success": "Parola başarıyla değiştirildi.",
    "user.changePassword.error": "Parola silme işlemi başarısız oldu. Lütfen tekrar deneyin.",
    "user.role.required": "Kullanıcı yetkisi boş olamaz",
    "user.update.title": "Kullanıcı Güncelleme",
    "user.update.description": "Kullanıcıyı güncelleme bazı verilerin kaybolmasına neden olabilir. Devam etmek istiyor musunuz?",
    "user.delete.title": "Kullanıcı Silme",
    "user.delete.description": "Kullanıcısı silinecektir. Devam etmek istiyor musunuz?",
    "user.modal.tabs.general": "Genel",
    "user.modal.tabs.customerProject": "Müşteri / Proje",
    "user.modal.tabs.customerProject.tooltip": "Bu sekme Denetçi yetkisine sahip kullanıcılar içindir",
    "user.filter.keyword.placeholder": "Kullanıcı Adı, Soyadı, Unvan, E-posta ... Giriniz",
    "user.column.username": "Kullanıcı Adı",
    "user.column.firstName": "Ad",
    "user.column.lastName": "Soyad",
    "user.column.status": "Durum",
    "user.cloumn.role": "Yetki",
    "user.column.title": "Unvan",
    "user.column.mail": "E-posta",
    "user.column.filePermissions": "D. İzni",
    "user.column.client": "Müşteri Adı",
    "user.column.createDate": "Oluşturma Tarihi",
    "user.activeProjectCount": "Aktif Proje Sayısı",
    "user.validation.username.duplicate": "Kullanıcı adı daha önce kullanılmıştır.",

    "dashboard.title": "Gösterge Paneli",
    "dashboard.compare.panel": "Proje Karşılaştırma Paneli",
    "dashboard.project.title": "Proje Gösterge Paneli",

    "activityData.title": "Faaliyet Verileri",
    "activityData.goToDashboard": "Proje gösterge paneline ilerle",
    "activityData.scope3.title": "Tedarikçi Verileri Hakkında Bilgilendirme",
    "activityData.scope3.description": "Eğer aktarılmadığını düşündüğünüz tedarikçi verileri bulunuyorsa, bu veriler denetmen veya sistem yöneticisi onayından sonra ilgili sekmeye aktarılacaktır. Lütfen onay sürecinin tamamlanmasını bekleyiniz.",
    "activityData.carbonFootprint.alert.title": "Hesaplanmış karbon ayak izi verileriniz var mı?",
    "activityData.carbonFootprint.alert.description": "Önceden hesaplanmış karbon ayak izi verileriniz varsa, bu alandan toplu veri girişi işlemini başlatabilirsiniz. “Emisyon Girişi Yap” butonuna tıklayarak mevcut verilerinizi hızlıca yükleyin.",
    "activityData.carbonFootprint.alert.button": "Emisyon Girişi Yap",

    "supplier.title": "Tedarikçiler",
    "supplier.newSupplier": "Yeni Tedarikçi",
    "supplier.definition.title": "Tedarikçi Tanımlama",
    "supplier.createNewSupplier": "Yeni Tedarikçi Oluştur",
    "supplier.save.success": "Tedarikçi başarıyla kaydedildi.",
    "supplier.save.error": "Tedarikçi kaydı başarısız oldu. Lütfen tekrar deneyin.",
    "supplier.delete.title": "Tedarikçi Sil",
    "supplier.delete.message": "Bu tedarikçiyi silmek istediğinize emin misiniz?",
    "supplier.delete.success": "Tedarikçi başarıyla silindi.",
    "supplier.delete.error": "Tedarikçi silme işlemi başarısız oldu. Lütfen tekrar deneyin.",
    "supplier.filter.customer.title": "Müşteriler",
    "supplier.filter.customer.placeholder": "Müşteri Seçiniz",
    "supplier.filter.keyword.placeholder": "Tedarikçi Ünvanı, Adı, Vergi Dairesi ... Giriniz",
    "supplier.relationships": "Tedarikçi İlişkileri",
    "supplier.relationships.placeholder": "Tedarikçi ilişkisi seçiniz",
    "supplier.subRelationship": "Tedarikçi Alt İlişkisi",
    "supplier.subRelationship.placeholder": "Tedarikçi alt ilişkisi seçiniz",
    "supplier.relation.save.success": "İlişki başarıyla kaydedildi.",
    "supplier.relation.save.error": "İlişki kaydı başarısız oldu. Lütfen tekrar deneyin.",
    "supplier.relation.alert.unmapped": "İlişkiler henüz tanımlanmamış",
    "supplier.relation.alert.allMapped": "Tüm ilişkiler tanımlandı",
    "supplier.relation.button.define": "İlişkiyi Tanımla",
    "supplier.relation.button.view": "İlişkileri Görüntüle",
    "supplier.relation.notFound": "İlişkilendirilmiş tedarikçi bulunamadı",

    "notification.title": "Bildirimler",
    "notification.markAsRead": "Okundu Olarak İşaretle",
    "notification.column.type": "Bildirim Tipi",
    "notification.column.description": "Açıklama",
    "notification.column.readStatus": "Okundu Durumu",
    "notification.column.createdBy": "Oluşturan",
    "notification.column.createdAt": "Oluşturulma Tarihi",
    "notification.column.readAt": "Okunma Tarihi",
    "notification.filter.type.placeholder": "Bildirim Durumu Seçiniz",
    "notification.filter.keyword.placeholder": "Kullanıcı, Adı, Soyadı, Açıklama ... Giriniz",

    "customer.title": "Müşteriler",
    "customer.newCustomer": "Yeni Müşteri",
    "customer.createNewCustomer": "Yeni Müşteri Oluştur",
    "customer.save.success": "Müşteri başarıyla kaydedildi.",
    "customer.save.error": "Müşteri kaydı başarısız oldu. Lütfen tekrar deneyin.",
    "customer.delete.title": "Müşteri Sil",
    "customer.delete.message": "Bu müşteriyi silmek istediğinize emin misiniz?",
    "customer.delete.success": "Müşteri başarıyla silindi.",
    "customer.delete.error": "Müşteri silme işlemi başarısız oldu. Lütfen tekrar deneyin.",
    "customer.filter.status.title": "Durum",
    "customer.filter.status.placeholder": "Aktiflik durumu seçiniz",
    "customer.filter.supplier.title": "Tedarikçiler",
    "customer.filter.supplier.placeholder": "Tedarikçi seçiniz",
    "customer.filter.organizationBoundaryMethods.title": "Kuruluş Sınırları",
    "customer.filter.organizationBoundaryMethods.placeholder": "Kuruluş sınır yöntemleri seçiniz",
    "customer.filter.keyword.placeholder": "Müşteri Ünvanı, Adı, Vergi Dairesi ... Giriniz",
    "customer.options.active": "Aktif",
    "customer.options.inactive": "Pasif",

    "client.column.companyName": "Şirket Adı",
    "client.column.name": "Adı",
    "client.column.boundaryMethod": "Kuruluş Sınırları",
    "client.column.status": "Durum",
    "client.column.person": "İletişim Kişisi",
    "client.column.email": "E-posta",
    "client.column.phone": "Telefon",
    "client.column.taxNumber": "Vergi Numarası",
    "client.column.taxOffice": "Vergi Dairesi",
    "client.column.address": "Adres",
    "client.column.city": "Şehir",
    "client.column.region": "İlçe",
    "client.column.country": "Ülke",

    "emission.analysis": "Emisyon Analizi",
    "emission.totals": "Emisyon Toplamları",
    "emission.supplierEmissions": "Tedarikçi Emisyonları",
    "emission.type.supplierAllocation": "Aktarılmış Emisyon",
    "emission.type.providedEmission": "Hesaplanmış Emisyon",
    "emission.totalCards.noData": "Emisyon toplam kartlarının gösterimi için henüz veri girişi yapılmamış. Başlamak için {link} tıklayınız.",
    "emission.graph.noData": "CO₂e emisyonlarıyla ilgili grafik gösterimi için henüz veri girişi yapılmamış.",
    "emission.map.noData": "Değer zinciri haritasını görüntüleyebilmek için tedarikçi verilerinin denetmen veya sistem yöneticisi tarafından onaylanması gerekmektedir.",
    "emission.waterTreatment": "Su Arıtması",
    "emission.column.purch.lineItem": "Satılan Ürün Kalemi",
    "emission.column.sold.quantity": "Satılan Ürün Miktarı",
    "emission.column.activity": "Kullanım Aşaması Aktivitesi",
    "emission.column.functionalUnit.activityData": "Kullanım Ömrü Boyunca Faaliyet Verisi",
    "emission.column.year": "Yıl",
    "emission.column.loan-useful": "Miktar",
    "emission.column.dataset": "Veri Tabanı",
    "emission.column.emissionSource": "Emisyon Kaynağı",
    "emission.column.sectorInfo": "Detay Bilgisi",
    "emission.column.hotelName": "Otel İsmi",
    "emission.column.employeeName": "Çalışan İsmi",
    "emission.column.arrivalDate": "Giriş Tarihi",
    "emission.column.departureDate": "Seyahat Tarihi",
    "emission.column.checkIn": "Giriş Tarihi",
    "emission.column.checkOut": "Çıkış Tarihi",
    "emission.column.durationIndex": "Gece Sayısı",
    "emission.column.peopleCount": "Kişi Sayısı",
    "emission.column.country": "Ülke",
    "emission.column.unit": "Birim",
    "emission.column.value": "Değer",
    "emission.column.fuelType": "Yakıt Türü",
    "emission.column.airportDeparture": "Kalkış Havalimanı",
    "emission.column.airportArrival": "Varış Havalimanı",
    "emission.column.distance": "Mesafe/Kullanıcı Verisi",
    "emission.column.flightClass": "Uçuş Sınıfı",
    "emission.column.gasType": "Gaz Türü",
    "emission.column.gasAmount": "Gaz Miktarı",
    "emission.column.gasLeakageRate": "Kaçak Gaz Oranı",
    "emission.column.emissionCO2": "Emisyon CO₂",
    "emission.column.emissionCH4": "Emisyon CH₄",
    "emission.column.emissionN2O": "Emisyon N₂O",
    "emission.column.emissionCO2e": "Emisyon CO₂e",
    "emission.column.description": "Açıklama",
    "emission.column.transportType": "Ulaşım Türü",
    "emission.column.amount": "Miktar",
    "emission.column.actionDate": "Eylem Tarihi",
    "emission.column.documentName": "Doküman Adı",
    "emission.column.documentDate": "Doküman Tarihi",
    "emission.column.kyoto.onlyKyotoEmissions": "Yalnızca Kyoto sera gazları içeren emisyonlar",
    "emission.column.kyoto.totalEmissionsIncludingNonKyoto": "Kyoto dışı sera gazları dahil toplam emisyonlar",
    "emission.column.kyoto.onlyNonKyotoEmissions": "Yalnızca Kyoto dışı sera gazları içeren emisyonlar",
    "emission.column.nace": "İlişki",
    "emissio.column.lowerHeatingValue": "Alt Isıl Değer",
    "emission.column.density": "Yoğunluk",
    "emissions.totalCalculated": "Hesaplanmış Toplam Emisyonlar",
    "emissions.valueChainMap": "Değer Zinciri Haritası",
    "emission.column.percentWithinSuppliers": "Tedarikçiler İçindeki Pay (%)",
    "emission.column.percentWithinAll": "Toplam Emisyon İçindeki Pay (%)",
    "emission.options.stationary.name": "Sabit ürün",
    "emission.options.mobile.name": "Hareketli ürün",
    "emission.options.fertilizer.name": "Gübre",
    "emission.options.process.name": "Proses ürünü",
    "emission.options.refrigerant.name": "Soğutucu gaz",
    "emission.options.fireExt.name": "Yangın tüpü",

    "emissionStatements.title": "Emisyon Faktörleri",
    "emissionStatements.newEmissionStatement": "Yeni Emisyon Faktörü",
    "emissionStatements.registeredEmissionFactors": "Kayıtlı Emisyon Faktörleri",
    "emissionStatements.column.greenhouseGas": "Sera Gazı",
    "emissionStatements.column.unit": "Birim",
    "emissionStatements.column.value": "Değer",
    "emissionStatements.column.total": "Toplam",
    "emissionStatements.column.fuelType": "Yakıt Türü",
    "emissionStatements.uploadFile.hint": "Bir adet yükleme yapabilirsiniz. Yalnızca Excel dosyaları",
    "emissionStatements.uploadFile.error": "Dosya yükleme işlemi başarısız oldu. Lütfen tekrar deneyin.",

    "emissionFactor.wizard.title": "Yeni Emisyon Faktörü",
    "emissionFactor.wizard.subtitle": "Emisyon Faktörü Tanımlama",
    "emissionFactor.wizard.level1": "Seviye 1",
    "emissionFactor.wizard.level1.placeholder": "Seviye 1 Seçiniz",
    "emissionFactor.wizard.level2": "Seviye 2",
    "emissionFactor.wizard.level2.placeholder": "Seviye 2 Seçiniz",
    "emissionFactor.wizard.level3": "Seviye 3",
    "emissionFactor.wizard.level3.placeholder": "Seviye 3 Seçiniz",
    "emissionFactor.wizard.fuelName": "Yakıt Adı",
    "emissionFactor.wizard.fuelType": "Yakıt Türü",
    "emissionFactor.wizard.fuelUnit": "Yakıt Birimi",
    "emissionFactor.wizard.step1": "Yakıt Tipi",
    "emissionFactor.wizard.step2": "Değer",
    "emissionFactor.wizard.totalStatementValue": "Toplam Değer",

    "emissionFactor.wizard.onlyKyotoGases": "Yalnızca Kyoto sera gazları içeren emisyonlar",
    "emissionFactor.wizard.onlyNonKyotoGases": "Yalnızca Kyoto dışı sera gazları içeren emisyonlar",
    "emissionFactor.wizard.totalIncludingNonKyoto": "Kyoto dışı sera gazları dahil toplam emisyonlar",

    "emissionFactor.wizard.onlyKyotoGasesValue": "Yalnızca Kyoto sera gazları içeren emisyonlar - Değer",
    "emissionFactor.wizard.onlyKyotoGasesUnit": "Yalnızca Kyoto sera gazları içeren emisyonlar - Birim",
    "emissionFactor.wizard.onlyNonKyotoGasesValue": "Yalnızca Kyoto dışı sera gazları içeren emisyonlar - Değer",
    "emissionFactor.wizard.onlyNonKyotoGasesUnit": "Yalnızca Kyoto dışı sera gazları içeren emisyonlar - Birim",
    "emissionFactor.wizard.totalIncludingNonKyotoValue": "Kyoto dışı sera gazları dahil toplam emisyonlar - Değer",
    "emissionFactor.wizard.totalIncludingNonKyotoUnit": "Kyoto dışı sera gazları dahil toplam emisyonlar - Birim",

    "emissionFactor.versionUpdate.title": "Emisyon faktörleri için yeni bir versiyon mevcuttur.",
    "emissionFactor.versionUpdate.description": "\"{projectName}\" Projesine ait hesaplama işlemlerinde kullandığınız 'Emisyon Faktörleri' değerleri eski bir versiyona aittir. Tüm değerlerinizi yeni versiyonda kullanılan 'Emisyon Faktörleri' değerlerine göre değiştirmek ister misiniz?",

    "fileHandler.title": "Dosya Yöneticisi",
    "fileHandler.filter.fileType": "Dosya Türü",
    "fileHandler.filter.fileType.placeholder": "Dosya Türü Seçiniz",
    "fileHandler.filter.keyword.placeholder": "Dosya Adı, Açıklaması ... Giriniz",
    "fileHandler.column.fileName": "Dosya Adı",
    "fileHandler.column.fileType": "Dosya Türü",
    "fileHandler.column.uploadedBy": "Yükleyen",
    "fileHandler.column.uploadedAt": "Yüklenme Tarihi",
    "fileHandler.column.description": "Açıklama",
    "fileHandler.column.size": "Boyut",
    "fileHandler.column.location": "Lokasyon",
    "fileHandler.view.unAuthorized": "Dosya görüntüleme izniniz bulunmamaktadır.",
    "fileHandler.delete.error": "Dosya silme işlemi başarısız oldu. Lütfen tekrar deneyin.",
    "fileHandler.delete.success": "Dosya başarıyla silindi.",
    "fileHandler.delete.warning": "Bu dosyayı silmek istediğinize emin misiniz?",
    "fileHandler.description.placeholder": "Açıklama giriniz",
    "fileHandler.preview.error": "Dosya önizlenemiyor.",
    "fileHandler.download.error": "Dosya indirilemedi",
    "fileHandler.select.required": "Lütfen yüklenecek bir dosya seçin.",
    "fileHandler.uploaded": "Yüklü Dosyalar",
    "fileHandler.operations": "Dosya İşlemleri",
    "fileHandler.none.title": "Yüklenmiş herhangi bir dosya bulunmamaktadır.",
    "fileHandler.none.subtitle": "Dosya yükleyebilir veya yöneticinizle iletişime geçebilirsiniz.",

    "action.reset": "Sıfırla",
    "action.sendRequest": "İstek Gönder",
    "action.delete": "Sil",
    "action.delete.confirm": "Silmek istediğinize emin misiniz?",
    "action.edit": "Düzenle",
    "action.save": "Kaydet",
    "action.cancel": "İptal",
    "action.cancel.confirm": "İptal etmek istediğinize emin misiniz?",
    "action.add": "Ekle",
    "action.search": "Ara",
    "action.update": "Güncelle",
    "action.clear": "Temizle",
    "action.dataEntry": "Veri Girişi",
    "action.uploadFile": "Dosya Yükle",
    "action.uploadFile.description": "Dosyayı yüklemek için bu alana tıklayın veya sürükleyin",
    "action.uploadFile.hint": "Bir adet yükleme yapabilirsiniz.",
    "action.refresh": "Yenile",
    "action.exportExcel": "Excel'e Aktar",
    "action.undoChanges": "Değişiklikleri Geri Al",
    "action.ok": "Tamam",
    "action.discardChanges": "Değişiklikleri İptal Et",
    "action.back": "Geri",
    "action.next": "İleri",
    "action.remove": "Kaldır",
    "action.changePassword": "Parola Değiştir",
    "action.sendInvitation": "Davetiye Gönder",
    "action.addRow": "Satır Ekle",
    "action.airportSearch": "Havalimanı Ara",
    "action.copy": "Kopyala",
    "action.approveAll": "Tümünü Onayla",
    "action.cancelAll": "Tümünü İptal Et",
    "action.approve": "Onayla",
    "action.approval.confirmMessage": "Verileri onaylanacaktır. Devam etmek istiyor musunuz?",
    "action.approval.revokeConfirm": "Onay işlemi geri çekilecektir. Devam etmek istiyor musunuz?",
    "action.close": "Kapat",
    "action.hide": "Gizle",
    "action.show": "Göster",
    "action.download": "İndir",
    "action.approve.selected": "Seçileni onayla",
    "action.revoke.selected": "Seçili onayı iptal et",
    "table.selection.mixed.status.warning": "Seçili satırların onay durumları farklı.",
    "table.selection.empty": "Geçerli seçili kayıt yok.",

    "filter.title": "Arama Ayarları",
    "filter.apply": "Filtre Uygula",
    "filter.applied": "Filtre Uygulandı",
    "filter.keyword.title": "Anahtar Kelime",
    "filter.rangePicker.title": "Tarih Aralığı",

    "sort.title": "Sıralama",
    "sort.projectName.asc": "Proje Adı (A-Z)",
    "sort.projectName.desc": "Proje Adı (Z-A)",
    "sort.date.desc": "Yeni Tarihli Önce",
    "sort.date.asc": "Eski Tarihli Önce",
    "sort.clientName.asc": "Müşteri Adı (A-Z)",
    "sort.clientName.desc": "Müşteri Adı (Z-A)",
    "sort.companyName.asc": "Şirket Adı (A-Z)",
    "sort.companyName.desc": "Şirket Adı (Z-A)",
    "sort.username.asc": "Kullanıcı Adı (A-Z)",
    "sort.username.desc": "Kullanıcı Adı (A-Z)",

    "date.startEnd": "Başlangıç/Bitiş",
    "date.end": "Bitiş Tarihi",
    "date.start": "Başlangıç Tarihi",
    "date.today": "Bugün",
    "date.yesterday": "Dün",
    "date.last3Days": "Son 3 Gün",
    "date.lastWeek": "Son 1 Hafta",
    "date.lastMonth": "Son 1 Ay",
    "date.last3Months": "Son 3 Ay",
    "date.last6Months": "Son 6 Ay",
    "date.lastYear": "Son 1 Yıl",
    "date.format": "DD-MM-YYYY",
    "date.formatAddTime": "DD-MM-YYYY HH:mm:ss",
    "date.formatAddTimeExtendedAccountPage": "DD-MM-YYYY HH:mm:ss",
    "date.customFormat": "D MMMM YYYY",
    "date.monthYear": "MM/YYYY",

    "table.columnSettings": "Sütun Göster/Gizle/Sırala",
    "table.columnNotVisible": "Sütun Gösterilmiyor",

    "form.project": "Proje",
    "form.project.placeholder": "Proje Seçiniz",
    "form.customer": "Müşteri",
    "form.customer.placeholder": "Müşteri Seçiniz",
    "form.customer.required": "Müşteri zorunludur!",
    "form.supplier": "Tedarikçi",
    "form.supplier.placeholder": "Tedarikçi seçiniz",
    "form.supplier.required": "Tedarikçi zorunludur!",
    "form.account": "Hesap",
    "form.companyName": "Unvan",
    "form.companyName.placeholder": "Örneğin: Life İklim ve Enerji Ltd. Şti.",
    "form.companyName.required": "Unvan zorunludur!",
    "form.shortTitle": "Kısa Unvan",
    "form.shortTitle.placeholder": "Örneğin: Life İklim",
    "form.shortTitle.required": "Kısa unvan zorunludur!",
    "form.contactPerson": "İletişim Kişisi",
    "form.contactPerson.required": "İletişim kişisi zorunludur!",
    "form.email": "E-posta",
    "form.email.label": "E-posta Adresi",
    "form.email.required": "Lütfen e-posta adresinizi giriniz!",
    "form.email.invalid": "Geçerli bir e-posta adresi giriniz!",
    "form.phone": "Telefon",
    "form.phone.required": "Telefon zorunludur!",
    "form.taxNumber": "Vergi Numarası",
    "form.taxNumber.required": "Vergi numarası zorunludur!",
    "form.taxOffice": "Vergi Dairesi",
    "form.taxOffice.required": "Vergi dairesi zorunludur!",
    "form.address": "Adres",
    "form.address.required": "Adres zorunludur!",
    "form.city": "Şehir",
    "form.city.required": "Şehir zorunludur!",
    "form.region": "İlçe",
    "form.region.required": "İlçe zorunludur!",
    "form.country": "Ülke",
    "form.country.placeholder": "Ülke seçiniz",
    "form.country.required": "Ülke zorunludur!",
    "form.nace": "NACE Kodu",
    "form.nace.placeholder": "NACE kodu giriniz",
    "form.nace.required": "NACE kodu zorunludur!",
    "form.naceCode.selectionOptional": "Nace Kodu - Seçim isteğe bağlıdır. Seçilmediği takdirde, NACE kodu müşteri bilgisinden alınır",
    "form.organizationBoundaryMethods": "Kuruluş Sınır Yöntemleri",
    "form.organizationBoundaryMethods.placeholder": "Kuruluş Sınır Yöntemleri Seçiniz",
    "form.organizationBoundaryMethods.required": "Kuruluş sınırları zorunludur!",
    "form.annualProductionVolume": "Üretim Hacmi (%)",
    "form.annualProductionVolume.placeholder": "Bu müşteriye tahsis edilen üretim hacmi oranı (örn. %25)",
    "form.organizationFundingShare": "Kuruluş Finansmanı Payı",
    "form.organizationFundingShare.placeholder": "Kuruluş finansman oranı (örn. %25)",
    "form.annualProductionVolume.required": "Yıllık üretim hacmi alanının doldurulması zorunludur!",
    "form.filePermissions": "Dosya İzinleri",
    "form.role": "Yetki",
    "form.role.placeholder": "Yetki seçiniz",
    "form.projectName": "Proje Adı",
    "form.username": "Kullanıcı Adı",
    "form.username.required": "Kullanıcı adı alanının doldurulması zorunludur.",
    "form.oldPassword": "Eski Parola",
    "form.newPassword": "Yeni Parola",
    "form.confirmPassword": "Yeni Parola (Tekrar)",
    "form.newPassword.required": "Lütfen yeni parolanızı giriniz (boş bırakılamaz)!",
    "form.newPassword.minLength": "Parola en az 6 karakter olmalıdır!",
    "form.confirmPassword.required": "Lütfen yeni parolanızı tekrar giriniz (boş bırakılamaz)!",
    "form.confirmPassword.mismatch": "Yeni parola ve tekrar girilen parola eşleşmiyor!",
    "form.firstName": "Ad",
    "form.firstName.required": "Ad alanının doldurulması zorunludur.",
    "form.lastName": "Soyad",
    "form.lastName.required": "Soyad alanının doldurulması zorunludur.",
    "form.addCustomer": "Müşteri Ekle",
    "form.title": "Unvan",
    "form.startEndDate": "Başlangıç - Bitiş Tarihi",
    "form.companyName.title.required": "Lütfen şirket unvanınızı eksiksiz ve tam olarak giriniz!",
    "form.requiredField": "Zorunlu alan!",
    "form.email.preferredLocale.label": "Mail Dil Tercihi",
    "form.email.preferredLocale.help": "Size gönderilecek e-postaların dilini seçin.",
    "form.email.preferredLocale.option.trTR": "Türkçe",
    "form.email.preferredLocale.option.enUS": "İngilizce",
    "form.flight.notData.label": "Uçuş verisi değildir",
    "form.longitude.placeholder": "Boylamı giriniz (örneğin: 41.0082)",
    "form.latitude.placeholder": "Enlemi giriniz (örneğin: 28.9784)",
    "form.coordinates": "Koordinatlar",
    "form.district": "İlçe",
    "form.coordinates.invalid": "Geçersiz koordinat formatı. Lütfen 'enlem, boylam' formatında giriniz.",

    "wizard.projectNetwork": "Proje Ağı",
    "wizard.selection.none": "Henüz seçim yapmadınız",
    "wizard.tabs.title.general": "Genel",
    "wizard.tabs.title.user": "Kullanıcı",
    "wizard.purchasedQuantity": "Satın alınan ürün miktarı",
    "wizard.noDataDueToNoSupplier": "Tedarikçi seçimi yapılmadığı için veri gelmemektedir.",

    "search.placeholder.generic": "Arama yapabilirsiniz",
    "search.placeholder.taxNumber": "Vergi kimlik numarasına göre arama yapabilirsiniz",

    "validation.fillAllSelections": "Lütfen tüm GHG ve ISO seçimlerini tamamlayın.",

    "travel.air": "Hava Yolu",
    "travel.sea": "Deniz Yolu",
    "travel.land": "Kara Yolu",

    "trip.oneWay": "Tek Yön",
    "trip.roundTrip": "Gidiş/Dönüş",

    "admin": "Sistem Yöneticisi",
    "customer": "Müşteri",
    "supplier": "Tedarikçi",
    "auditor": "Denetçi",

    "FinancialControl": "Mali Kontrol",
    "OperationalControl": "Operasyonel Kontrol",
    "EquityShare": "Öz kaynak Payı",

    "scope1": "Kapsam 1",
    "scope2": "Kapsam 2",
    "scope3": "Kapsam 3",
    "category1": "Kategori 1",
    "category2": "Kategori 2",
    "category3": "Kategori 3",
    "category4": "Kategori 4",
    "category5": "Kategori 5",
    "category6": "Kategori 6",

    "stationaryCombustionGHG": "Sabit Yanma",
    "processEmissionsGHG": "Proses Emisyonları",
    "fugitiveEmissionsGHG": "Kaçak Emisyonlar",
    "mobileCombustionGHG": "Hareketli Yanma",
    "electricityPurchasesGHG": "İthal Edilen Elektrik",
    "purchasedHeatEmissionsGHG": "İthal Edilen Enerji",
    "purchasedGoodsEmissionsGHG": "Satın Alınan Mal ve Hizmetler",
    "capitalGoodsEmissionsGHG": "Sermaye Malları",
    "otherGHG": "Yakıt ve Enerjiyle İlgili Faaliyetler",
    "upstreamTransportationEmissionsGHG": "Yukarı Yönlü Nakliye ve Dağıtım",
    "operationalWasteEmissionsGHG": "Operasyonlarda Oluşan Atıklar",
    "flightsGHG": "İş Seyahatleri",
    "employeeCommutingEmissionsGHG": "Çalışan Ulaşımı",
    "leasedAssetsEmissionsGHG": "Kiralanan Varlıklar",
    "downstreamTransportationEmissionsGHG": "Aşağı Yönlü Nakliye ve Dağıtım",
    "purchasingProcessingGHG": "Satılan Ürünlerin İşlenmesi",
    "productUseEmissionsGHG": "Satılan Ürünlerin Kullanımı",
    "eolGHG": "Satılan Ürünlerin Kullanım Ömrü Sonu İşlemleri",
    "leasedAssetsDownstreamEmissionsGHG": "Kiraya Verilen Varlıklar",
    "franchiseBranchEmissionsGHG": "Bayilikler",
    "investmentEmissionsGHG": "Yatırımlar",

    "stationaryCombustionISO": "Sabit Yanma",
    "mobileCombustionISO": "Hareketli Yanma",
    "processEmissionsISO": "Proses Emisyonları",
    "fugitiveEmissionsISO": "Kaçak Emisyonlar",
    "lulucfEmissionsISO": "Arazi ve Orman Faaliyetleri",
    "purchasedElectricityEmissionsISO": "İthal Edilen Elektrik",
    "purchasedHeatEmissionsISO": "İthal Edilen Enerji",
    "upstreamTransportationEmissionsISO": "Yukarı Yönlü Nakliye ve Dağıtım",
    "downstreamTransportationEmissionsISO": "Aşağı Yönlü Nakliye ve Dağıtım",
    "employeeCommutingEmissionsISO": "Çalışan Ulaşımı",
    "clientTransportEmissionsISO": "Müşteri ve Ziyaretçilerin Ulaşımı",
    "businessTravelEmissionsISO": "İş Seyahatleri",
    "purchasedMaterialsISO": "Satın Alınan Mallar",
    "capitalGoodsEmissionsISO": "Sermaye Malları",
    "operationalWasteEmissionsISO": "Katı ve Sıvı Atıkların Bertarafı",
    "leasedAssetsEmissionsISO": "Kiralanan Varlıkların Kullanımı",
    "purchasedGoodsEmissionsISO": "Satın Alınan Hizmetler",
    "productUseEmissionsISO": "Ürünün Kullanımı Aşaması",
    "leasedAssetsDownstreamEmissionsISO": "Kiraya Verilen Varlıkların Kullanımı",
    "eolISO": "Satılan Ürünlerin Kullanım Ömrü Sonu İşlemleri",
    "investmentEmissionsISO": "Yatırımlar",
    "otherISO": "Diğer",

    "taxNumber.notFound.invite": "Vergi numarasına ait kayıt bulunamadı. E-posta adresini girerek davet edebilirsiniz.",

    "relation.dir.up": "Kuruluşa Gelen (Yukarı Yönlü)",
    "relation.dir.down": "Kuruluştan Giden (Aşağı Yönlü)",
    "relation.dir.unknown": "Diğer"
  }
};

export default TrLang;
